import { MutationTree } from 'vuex'
import { IBusinessState, IBusinessUser } from '@/@types'

const mutations: MutationTree<IBusinessState> = {
  BUSINESS_USER_UPDATED: (state, user: IBusinessUser) => {
    state.businessUser = user
  },
}

export default mutations
